module.exports = __webpack_public_path__ + "static/media/Drone.0902bc97.svg";